import { EntityGrantedPermissions } from 'packages/store/sharing/types';
import { CategoryReference } from 'packages/store/templates/types';

export type CategoryPermissionsGroup = {
    category: CategoryReference;
    permissions: EntityGrantedPermissions[];
};

export const groupProjectPermissionsByCategory = (
    items: EntityGrantedPermissions[],
    categories: CategoryReference[],
): CategoryPermissionsGroup[] =>
    categories.reduce<CategoryPermissionsGroup[]>((groups, category) => {
        const permissions = items.reduce<EntityGrantedPermissions[]>((acc, item) => {
            const projectGrantedPermissions = (item.projectGrantedPermissions ?? []).filter(
                ({ projectId }) => projectId === String(category.id),
            );

            if (projectGrantedPermissions.length) {
                acc.push({ ...item, projectGrantedPermissions });
            }

            return acc;
        }, []);

        if (permissions.length) {
            groups.push({ category, permissions });
        }

        return groups;
    }, []);
